export default "__VITE_ASSET__CDzGj3dN__"